import React, {Component} from 'react';
import PrintPreview from './PrintPreview'
import JobControlBoardTable from '../workdoc/jobcontrol/JobControlBoardTable'
import ReportStore from '../../stores/ReportStore'
import {connect} from 'react-redux'
// const localStorageKey3 = 'kkc.jobControlBoard.filter'
class PrintReportJobControlBoard extends Component {

  constructor(...args){
    super(...args)

    if(this.props.control==="recheck"){
      this.defaultHeaderTitles = [
        { title: this.props.messages['Fixing Job No'], field: 'work_no', sorting: true, direction:'', onClick:()=>{} },
        { title: this.props.messages['Car Registration'], field: 'car_registration_no' },
        { title: this.props.messages['Brand/Model'], field: 'car_detail' },
        { title: this.props.messages['Customer'], field: 'customer_name' }    
      ]
    }else{
      this.defaultHeaderTitles = undefined
    }
    this.state = {
      loading:false,
      componentList:[],
      itemPerPage:10,
      filter_tb:{assemblyState:false,cleanState:false,createJobState:false,dismanlingState:false,groundState:false,hitState:false,mixColorState:false,paintState:false,polishState:false,qcState:false,trapState:false},
      hasFilterSel:false
      // filter_tb: JSON.parse(localStorage.getItem(localStorageKey3)) || {
      //   createJobState:false,
      //   dismanlingState:false,
      //   hitState:false,
      //   trapState:false,
      //   groundState:false,
      //   mixColorState:false,
      //   paintState:false,
      //   assemblyState:false,
      //   polishState:false,
      //   cleanState:false,
      //   qcState:false
      // }
      
    }
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    let { itemPerPage} = this.state
    if (this.props.control==='workJobOffice')
      this.loadWorkOfficeList(itemPerPage)
    else if (this.props.control==='recheck')
      this.loadRecheckList(itemPerPage)
    else
      this.loadWorkList(itemPerPage)
  }

  componentDidUpdate(){
    const {componentList,workState} = this.state
    
    componentList.map((item,index)=>{
      
      //that.refs['jcbTable'+index].loadData(item,workState) 
      this.refs['jcbTable'+index].getWrappedInstance().loadData(item,workState) 
      return item
    })
  }

  setData(result,itemPerPage) {
    let {control,printRecvCarDocState,quotationState,crateJobState,purchasingState,partState,financeState,recvPaymentState,reproFinState,assemblyState,cleanState,createJobState,dismanlingState,groundState,hitState,mixColorState,paintState,polishState,qcState,trapState,status} = this.props
    let filter_tb = {assemblyState:assemblyState,cleanState:cleanState,createJobState:createJobState,dismanlingState:dismanlingState,groundState:groundState,hitState:hitState,mixColorState:mixColorState,paintState:paintState,polishState:polishState,qcState:qcState,trapState:trapState}
    if (control==='recheck')
      filter_tb = {printRecvCarDocState:printRecvCarDocState,quotationState:quotationState,crateJobState:crateJobState,purchasingState:purchasingState,partState:partState,financeState:financeState,recvPaymentState:recvPaymentState,reproFinState:reproFinState}
    
    let data = result.data
    let itemlist = []
    let indexs = []
    let filter_key = []
    let isFilter = false
    let status_filter = []
    let hasFilterSel = false
    if (status!==undefined&&status!=='')
      status_filter = status.split(',')
    
    for (var key in filter_tb) {
      if (filter_tb[key]==='true') { 
        isFilter = true
        hasFilterSel = true
        filter_key.push(key)
      }  
    }
    if (filter_key.length===0&&status_filter.length>0) {
      for (var key in filter_tb) {
        isFilter = true
        filter_key.push(key)  
      }
    }
    if (isFilter) {
      data.forEach((item,index)=>{
        filter_key.forEach((sitem,sindex)=>{
          // if (item[sitem]!=='-1'&&item[sitem]!==undefined) {
          //   if (indexs.indexOf(index)===-1) {
          //     indexs.push(index)
          //     itemlist.push(item)
          //   }  
          // }
          /////////////////////////////
          if (status_filter.length>0) {
            let val = item[sitem]*1
            if (val%1>0) {
              let mod = val%1
              val = val-mod
              val = val.toString()
            } else
              val = val.toString()
            if (status_filter.indexOf(val)!==-1&&item[sitem]!==undefined) {
              if (indexs.indexOf(index)===-1) {
                indexs.push(index)
                itemlist.push(item)
              }
            }
          } else {
            if (item[sitem]!=='-1'&&item[sitem]!==undefined) {
              if (indexs.indexOf(index)===-1) {
                indexs.push(index)
                itemlist.push(item)
              }  
            }
          }
        })
      })
    } else 
      itemlist = JSON.parse(JSON.stringify(data))
    
    const length = Math.ceil(itemlist.length/itemPerPage)
    const componentList = new Array(length).fill('').map((item,index)=>{
      let newData = itemlist.slice(index*itemPerPage, (index+1)*itemPerPage);
      return newData       
    }) 
    this.setState({ loading: false,componentList:componentList,workState:result.work_state,filter_tb:filter_tb, hasFilterSel:hasFilterSel })
  }

  loadWorkList(itemPerPage) {
    this.setState({ loading: true })
    ReportStore.loadReportWorkJobControl((result)=>{
      this.setData(result,itemPerPage)
    },()=>{
      this.setState({loading:false})
    })
  }

  loadWorkOfficeList(itemPerPage) {
    this.setState({ loading: true })
    ReportStore.loadReportWorkOfficeControl((result)=>{
      this.setData(result,itemPerPage)
    },()=>{
      this.setState({loading:false})
    })
  }

  loadRecheckList(itemPerPage) {
    this.setState({ loading: true })
    ReportStore.loadReportRecheckControl((result)=>{
      this.setData(result,itemPerPage)
    },()=>{
      this.setState({loading:false})
    })
  }

  renderWorkState() {
    let {workState} = this.state
    let {assemblyState,cleanState,createJobState,dismanlingState,groundState,hitState,mixColorState,paintState,polishState,qcState,trapState} = this.props
    let arrS = [
      {field:'dismanlingState',status:dismanlingState},
      {field:'hitState',status:hitState},
      {field:'trapState',status:trapState},
      {field:'groundState',status:groundState},
      {field:'mixColorState',status:mixColorState},
      {field:'paintState',status:paintState},
      {field:'assemblyState',status:assemblyState},
      {field:'polishState',status:polishState},
      {field:'cleanState',status:cleanState},
      {field:'qcState',status:qcState},
      {field:'createJobState',status:createJobState}
    ]
    let status_txt = ''
    if (arrS.findIndex(x=>x.status==='true')!==-1) {
      status_txt = 'ขั้นตอน: '
      let arrWS = []
      arrS.forEach((item,index)=>{
        if (item.status==='true') {
          let wsIndex = workState.findIndex(x=>x.value===item.field)
          if (wsIndex!==-1)
            arrWS.push(workState[wsIndex].label)
        }  
      })
      status_txt += arrWS.join()
      return <div style={{marginBottom:'5px'}}>{status_txt}</div>
    } else
      return
  }

  renderStatus() {
    let {status} = this.props
    if (status!==undefined) {
      let arrS = status.split(',')
      arrS = arrS.map((item,index)=>{
        if (item==='-1')
          return 'ยังไม่ได้เริ่มงาน'
        else if (item==='0')
          return 'รอเริ่มงาน'
        else if (item==='1')
          return 'กำลังซ่อม'
        else if (item==='2')
          return 'ซ่อมเสร็จในขั้นตอน'
        else if (item==='3')
          return 'หยุดชั่วคราว'      
      })
      return(<div>สถานะ: {arrS.join()}</div>)
    } else
      return
  }

  renderComponentPage(){
    const {componentList,filter_tb,hasFilterSel} = this.state
    let {hideFilterNoSel} = this.props
    let hideNoSel = (hideFilterNoSel==='true'?true:false)
    return componentList.map((item,index)=>(
      <div key={index} className="print-report-jobcontrol-board">
        <div>
          <div className='text-center'>
            <h4>{this.props.control=='workJobOffice'?'รายงานควบคุมงานภายใน':this.props.control==='recheck'?'รายงานตรวจสอบข้อมูลงานซ่อม ':'รายงานสถานะการซ่อมรถ'}</h4>
          </div>
          <div style={{fontSize:'14px'}}>
            {this.renderWorkState()}
            {this.renderStatus()}
          </div>
        </div>
        <JobControlBoardTable hasFilterSel={hasFilterSel} filter_tb={filter_tb} hideNoSel={hideNoSel} mode='print' key={index} id={'jcbTable'+index} 
        ref={'jcbTable'+index} showWorkNo={false} showSearch={false} control={this.props.control}
        defaultHeaderTitles={this.defaultHeaderTitles}
         />
      </div>
    ))
  }

  onRowsPerPageChange(itemPerPage) {
    this.setState({itemPerPage:itemPerPage})
    if (this.props.control=='workJobOffice')
      this.loadWorkOfficeList(itemPerPage)
    else if (this.props.control=='recheck')
      this.loadRecheckList(itemPerPage)
    else
      this.loadWorkList(itemPerPage)
  }

  render(){
    const {itemPerPage,loading} = this.state
    return (
      <PrintPreview 
        loading={loading}
        size={'landscape'}
        leftBarTitle={this.props.control=='workJobOffice'?'รายงานควบคุมงานภายใน':this.props.control==='recheck'?'รายงานตรวจสอบข้อมูลงานซ่อม ':'รายงานสถานะการซ่อมรถ'}
        onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
      >
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }
}


export default PrintReportJobControlBoard = connect(
  (state) => ({messages: state.message.view.workdoc.jobcontrol.JobControlBoardTable}),null,null,{withRef:true}
)(PrintReportJobControlBoard);





// WEBPACK FOOTER //
// ./src/view/print/PrintReportJobControlBoard.js